export enum FeatureFlag {
  /* Maintenance and Triggers */
  HealthCheckCron = 'health-check-cron',
  Maintenance = 'maintenance',
  Refresh = 'force-refresh',
  Logout = 'force-logout',

  /* Feature Flags */
  AdaptiveCharts = 'adaptive-charts',
  AIPageBuilder = 'ai-page-builder',
  GlobalAIAssistant = 'global-ai-assistant',
  AiSearchWiderDashboard = 'ai-search-wider-dashboard',
  CompanyDiscoveryValuationFilter = 'company-discovery-valuation-filter',
  CustomDashViewEditToggle = 'custom-dash-view-edit-toggle',
  DashboardNewLayout = 'dashboard-new-layout',
  DataBuilderShareLinks = 'data-builder-share-links',
  DraggablePagesTabs = 'draggable-pages-tabs',
  CustomReports = 'custom-reports',
  CustomReportsSnowflake = 'custom-reports-snowflake',
  ExperimentalReports = 'experimental-reports',
  DiscoveryStateGeography = 'discovery-state-geography',
  GeographyUserPreference = 'geography-user-preference',
  Impersonation = 'impersonation',
  IndividualPotential = 'individual-potential-page',
  PostingDiscovery = 'postings-discovery',
  PostingsV3 = 'postings-v3',
  PPTPreview = 'ppt-preview',
  PromoteMarketConditionsReportTemplate = 'promote-market-conditions-report-template',
  PromoteOrgHealthReportTemplate = 'promote-org-health-report-template',
  PromoteSentimentReportTemplate = 'promote-sentiment-report-template',
  SelectionListIds = 'enable-selection-list-ids',
  SharedReports = 'shared-reports',
  SharedPlots = 'shared-plots',
  TalentDiscoveryStateGeography = 'talent-discovery-state-geography',
  TransitionsV3 = 'transitions-v3',
}
